module.exports = __webpack_public_path__ + "img/chest-1.317cbfc7.png";